import styled from "styled-components";
import Img from "../../../../assets/images/About_Page_Header.jpg";
import Img2 from "../../../../assets/images/6Rectangle.jpeg";
import DigitalSupplier from "../../../../assets/images/1ManagedServices.svg";
const Container = styled.div``;
const Wrapper = styled.div`
  /* padding: min(2.45vw, 35px) 0; */
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  button {
    background-color: #233354;
    font-weight: 400;
    color: rgb(255, 255, 255);
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }
  h2,
  h3,
  h4 {
    font-family: ITC Franklin Gothic Std;
  }
  p{
    font-size: 1.5rem;
   }
   h2 {
    font-size: 2.759rem;
  }
  h2{
    @media (max-width: 767px) {
        font-size: 1.5rem !important;
    }
  }
  p{
    @media (max-width: 767px) {
        font-size: 14px !important;
    }
  }
  .the_experience {
    background-color: #efefef;
    padding: 56px 20px;
    text-align: center;
    margin-top: 4vw;
    @media (max-width: 767px) {
      margin: 5.5vw 3.5vw !important;
      width: auto;
    }
    h2 {
      color: #233354;
      @media (max-width: 767px){
        font-size: 2rem;
      }
    }
    img {
      max-width: 105%;
    }
    p {
      margin: 8px 123px;
    }
    @media (max-width: 1024px) {
      p {
        margin: 8px 0;
      }
    }
    @media (max-width: 767px) {
      p {
        margin: 8px 0;
      }
    }
  }
  .the_experience_detail {
    padding: 30px 20px;
    margin: 0 3.5vw 2vw;
    .grid-box {
      display: grid;
      grid-template-columns: 155px 1fr;
      gap: 16px;
      p {
        margin: 10px 0;
      }
      @media (max-width: 1024px) {
        grid-template-columns: 118px 1fr;
        gap: 8px;
      }
      .bold {
        font-weight: 700;
      }
    }
  }
  .our_expertise {
    background-color: #e3f1fb;
    width: 100%;
    background-repeat: repeat;
    background-position: right;
    margin: 4vw 0 !important;
    &.indispensable{
      background-position: 55px center;
      background-repeat: no-repeat;
      background-image:url(${DigitalSupplier});
    }
    @media (max-width: 767px){
      &.indispensable{
        background-image: url(${DigitalSupplier});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 86%;
      }
    }
    &.suppliers {
      background-image: url(${Img2});
      background-size: cover;
    }

    .expertise_overlay {
      background: linear-gradient(109deg, #ee0000bf 50%, transparent 50%);
      height: 700px;
      color: #ffffff;
      padding: 16px;
      padding-left: 6.25vw;
      padding-right: 6.25vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      &.resource{
        /* background:linear-gradient(109deg, #B40001 50%, transparent 50%); */
        background: linear-gradient(109deg, #b40001d9 50%, transparent 50%);
        backdrop-filter: blur(0px);
        @media(max-width: 767px){
          background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb);
          /* background-color: #ee0000c4; */
          backdrop-filter: blur(1px);
          height: 324px;
        }
      }
      p{
        margin-top: 42px;
      }
      &.newsroom{
        background:linear-gradient(109deg, #b40001e0 50%, transparent 50%);
        height: 400px !important;
        @media (max-width: 767px){
          .max-w{
              margin-top: 0;
          }
        }
      }
      .digital_supplier_img {
        img {
          max-width: 495px;
          @media (max-width: 1023px) {
            max-width: 250px;
          }
        }
      }
      .max-w {
        max-width: 516px;
        @media (max-width: 1023px) {
          max-width: 264px;
        }
        @media (max-width: 767px){
          max-width: 300px;
          margin-top: 18px;
        }
      }
      .grid {
        display: grid;
        button {
          background-color: #ffffff;
          color: #ee0000;
          width: 270px;
          font-weight: 600;
        }
      }
    }
    @media (max-width: 1024px) {
      .expertise_overlay {
        height: 400px;
      }
    }
    @media (max-width: 767px) {
      background-size: cover;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .expertise_overlay {
        background: linear-gradient(180deg, #ee0000c4 52%, #e3f1fb 34%);
        background-color: #ee0000c4;
        height: 604px;
        flex-direction: column;
        h2 {
          font-size: 20px;
        }
        p {
          font-size: 14px;
        }
        .digital_supplier_img {
          display: none;
          img {
            max-width: 290px;
          }
        }
        .grid {
          display: grid;
          button {
            background-color: #ffffff;
            color: #ee0000;
            width: 300px;
          }
        }
      }
      &.suppliers {
        .expertise_overlay {
          background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb 34%);
          height: 202px !important;
          justify-content: center;
          button{
            margin-top: 18px;
          }
        }
      }
    }
  }

  .pallet_faq {
    margin: 2.5vw 3.5vw;
    @media (max-width: 767px) {
      margin: 5.5vw 3.5vw !important;
       &#library{
        padding: 7vw 16px !important;
        padding-bottom: 0 !important;
        h2{
          font-size: 1.7rem !important;
          display: contents;
        }
      }
        }
        @media (max-width: 1024px){
          margin: 3.5vw 3.5vw;
        }
    .faq-head {
      text-align: center;
      margin-bottom: 40px;
      h2 {
        /* font-size: 2rem !important; */
        font-family: ITC Franklin Gothic Std;
        color: #233354;
        @media (max-width: 767px) {
          font-size: 1.8rem !important;
        }
      }
      p {
        color: #231f20;
        font-size: 20px;
        max-width: 718px;
        text-align: center;
        margin: 16px auto;
      }
    }
    .buyer {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 32px;
      font-family: "latobold" !important;
      .red-bg {
        background-color: #95CDED;
        color: rgb(14, 87, 138);
        padding: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 16px 16px 0px 0px;
        &.orange {
          background-color: #0E578A;
          h2{
            color: #fff !important;
          }
          p{
            color: #fff !important;
          }
          
        }
        &.yellow {
          background-color: #F2CE77;
        }
        h2 {
          font-size: 24px;
          font-family: "latobold";
          margin: 0;
          color: #0E578A;
        }
        p{
          font-size: 17px;
          margin: 4px 0;
          color: #0E578A;
          font-family: "latosemibold";
        }
      }
      .buyer_body {
        border: 2px solid rgb(149, 205, 237);
        padding: 20px;
        background-color: #ffffff;
        min-height: 693px;
        display: grid;
        grid-template-rows: 1fr auto;
        border-radius: 0px 0px 16px 16px;
        &.orange-b {
          border: 2px solid rgb(14, 87, 138);
          button {
            background: #0E578A;
            color: #fff;
          }
        }
        &.yellow-b {
          border: 2px solid rgb(242, 206, 119);
          button {
            background: #F2CE77;
            color: #3C4251;
          }
        }
        .fa-check {
          margin-right: 10px;
          color: #00db05;
        }
        li {
          line-height: 36px;
          font-family: 'latoregular';
        }
        h5 {
          /* color: rgb(9, 85, 135); */
          text-align: center;
          font-size: 22px;
         font-family: latosemibold;
        }
        button {
          background: #95CDED;;
          color: #0E578A;
          border-radius: 4px;
          height: 45px;
          width: 250px;
        }
        @media (max-width: 1023px) {
          padding: 12px;
        }
      }
      @media (max-width: 1023px) {
        grid-template-columns: 1fr 1fr;
      }
      @media (max-width: 767px) {
        grid-template-columns: 1fr;
        .buyer_body {
          min-height: auto;
        }
      }
    }
    &.wrp-bg {
      background-color: #efefef;
      padding: 50px 40px;
      @media (max-width: 767px) {
        padding: 20px 10px;
      }
      .center-btn {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        button {
          background-color: #ed1c24;
        }
      }
    }
    .market{
      @media (max-width: 1024px){
          font-size:1.4rem;
        }
    }
  }
  .number-set {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 40px;
    margin-top: -26px;
    gap: 16px;
    grid-template-rows: repeat(3, 1fr);
    p{
      font-size: 20px;
    }
    .first {
      background-color: #f3f7ff;
      /* background-color: bisque; */
      padding: 15px 0;
    }
    .secound {
      background-color: #e3f1fb;
    }
    .txt-wrp {
      margin-left: 1rem;
      margin-right: 1rem;
      display: flex;
      align-items: center;
    }

    .item-container {
      display: flex;
      position: relative;
      .number-box {
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(-1rem, -4%);
        .number-shadow {
          font-weight: 800;
          font-size: 5.3rem;
          line-height: 100%;
          -webkit-text-fill-color: #fff;
          -webkit-text-stroke: 25px;
          color: #fff;
          z-index: 10;
          position: absolute;
          @media (max-width: 767px){
            -webkit-text-stroke: 15px;
          }
        }
        .number {
          font-size: 5.3rem;
          line-height: 50%;
          font-weight: 800;
          position: relative;
          z-index: 11;
        }
      }
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      .txt-wrp {
        margin-right: 0rem;
        min-height: 68px;
      }
      .item-container {
        .number-box {
          transform: translate(0rem, -4%);
          .number-shadow,
          .number {
            font-size: 3.3rem;
          }
        }
      }
    }
  }
  .item-container.first .number-box .number {
    color: #00a5d7;
  }
  .lead {
    display: none;
    .lead-group {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 20px;
      max-width: 1060px;
      margin: 0 auto;
      @media (max-width: 1023px) {
        grid-template-columns: repeat(4, 1fr);
      }
      @media (max-width: 767px) {
        grid-template-columns: repeat(2, 1fr);
      }
      .lead-box {
        position: relative;
        overflow: hidden;
        transition: all 0.5s;
        img {
          object-fit: cover;
          height: 100%;
          width: 100%;
        }
        .over-text {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
          background-color: #ffffff80;
          /* padding: 16px; */
          text-align: center;
          backdrop-filter: blur(2px);
          color: #233354;
          height: 0;
          transition: all 0.5s;
          display: grid;
          place-items: center;

          h4 {
            font-size: 18px;
            font-weight: 600;
          }
          p {
            font-size: 15px;
            margin: 6px 0;
          }
          @media (max-width: 767px) {
            h4 {
              font-size: 16px;
            }
            p {
              font-size: 13px;
            }
          }
        }
        &:hover {
          .over-text {
            height: 90px;
            transition: all 0.5s;
          }
        }
      }
    }
  }
  .careers {
    text-align: center;
    margin-top: 3vw;
    h2 {
      max-width: 500px;
      margin: 0 auto;
    }
  }
  @media (max-width: 1024px) {
    h2 {
      font-size: 1.7rem;
    }
    h4 {
      font-size: 1rem;
    }
    li {
      font-size: 14px;
    }
    p {
      font-size: 14px !important;
    }
  }
`;
const Banner = styled.div`
  h3{
    font-size: 1.4rem;
    /* font-size: 1.4rem; */
  }
  p{
    font-size: 1.5rem;
   }
   h2 {
    font-size: 2.759rem;
  }
  background-image: url(${Img});
  width: 100%;
  position: relative;
  background-repeat: round;
  background-position: top;
  background-size: contain;
  padding: 16px;
  height: 550px;
  display: flex;
  align-items: center;
  @media (max-width: 1023px) {
    height: 345px;
    h3{
      font-size: 1.1rem;
    }
  }
  .quote {
    position: fixed;
    z-index: 99;
    top: 318px;
    right: 0;
    div{
      margin-left: 0 !important;
    }
    @media (min-width: 1441px) {
      margin-right: calc(50vw - 726px);
    }
    @media (max-width: 1023px) {
      top: 252px;
    }
    @media (max-width: 767px) {
      top: 277px;
    }
    button {
      background-color: #ff0000c7;
      color: #fff;
      border: none;
      padding: 12px;
      font-size: 16px;
      width: 155px;
      margin-top: min(1.75vw, 25px);
    }
  }
  .banner-text {
    margin-left: 6.25vw;
    color: #ffffff;
    background: #00000047;
    padding: 40px;
    backdrop-filter: blur(2px);
    p {
      width: 308px;
    }
    h2 {
      font-weight: 500;
    }
    @media (max-width: 1024px){

       width: 459px;

      }
  }
  @media only screen and (min-width: 360px) and (max-width: 767px) {
    h3{
      font-size: 21px !important;
      display: contents;
    }
  }

  @media (max-width: 1024px) {
    .quote {
      bottom: 118px;
      button {
        padding: 8px;
        font-size: 14px;
        width: 155px;
      }
    }
  }
  @media (max-width: 767px) {
    background-size: cover;
    height: 410px;
    padding: 0;
    .banner-text {
        margin-left: -9px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 28px;
        height: 410px;
        padding-top: 7px;
      p {
        font-size: 21px !important;
        width: 80%;
      }
      h2 {
        font-size: 2rem !important;
        &.mb-4 {
      }
      h3{
        font-size: 23px;
      }
      }
    }
    .quote {
      bottom: 117px;
      button {
        padding: 4px;
        font-size: 11px;
        width: 132px;
      }
    }
  }
`;
const ButtonTwo = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
  p{
    font-size: 1.5rem;
   }
   h2 {
    font-size: 2.759rem;
  }
`;
export { Container, Wrapper, Banner, ButtonTwo };
